import AllProjects from "./icons/action/all_projects_20x20.svg";
import AllProjectsBW from "./icons/action/all_projects_bw_20x20.svg";
import BlastMini from "./icons/action/blast_20x20.svg";
import GenomeViewerMini from "./icons/action/genome_viewer_20x20.svg";
import NewProjects from "./icons/action/new_project_20x20.svg";
import ProcessorMini from "./icons/action/processor_20x20.svg";
import ProcessorBWMini from "./icons/action/processor_bw_20x20.svg";
import SampleMini from "./icons/action/sample_20x20.svg";
import SavedItemsMini from "./icons/action/saved_items_20x20.svg";
import WorkflowMini from "./icons/action/workflow_20x20.svg";
import SequenceViewerMini from "./icons/action/sequence_viewer_20x20.svg";
import SequenceViewerBWMini from "./icons/action/sequence_viewer_bw_20x20.svg";
import EntitySummaryBWMini from "../assets/icons/action/entity_summary_bw_20x20.svg";
import WorkflowBWMini from "./icons/action/workflow_bw_20x20.svg";
import SixteenS from "./icons/large/playbooks/16s_140x80.svg";
import Chart from "./icons/large/playbooks/chart_140x80.svg";
import Check from "./icons/large/playbooks/check_140x80.svg";
import Configuration from "./icons/large/playbooks/configuration_140x80.svg";
import Detection from "./icons/large/playbooks/detection_140x80.svg";
import Experiment from "./icons/large/playbooks/experiment_140x80.svg";
import Plants from "./icons/large/playbooks/plants_140x80.svg";
import Plate from "./icons/large/playbooks/plate_140x80.svg";
import Report from "./icons/large/playbooks/report_140x80.svg";
import Sample1 from "./icons/large/playbooks/sample_1_140x80.svg";
import Sample2 from "./icons/large/playbooks/sample_2_140x80.svg";
import Scan from "./icons/large/playbooks/scan_140x80.svg";
import TLA from "./icons/large/playbooks/tla_140x80.svg";
import Vegetables from "./icons/large/playbooks/vegetables_140x80.svg";
import Virus from "./icons/large/playbooks/virus_140x80.svg";
import Blast from "./icons/large/restricted/blast_140x80.svg";
import AnalyticalDataViewerLarge from "./icons/large/restricted/data_viewer_140x80.svg";
import PlaybookLarge from "./icons/large/restricted/default_140x80.svg";
import GenomeViewerLarge from "./icons/large/restricted/genome_viewer_140x80.svg";
import PlaybookConfiguration from "./icons/large/restricted/playbook_configuration_140x80.svg";
import Registration from "./icons/large/restricted/registration_140x80.svg";
import WorkflowLarge from "./icons/large/restricted/workflow_140x80.svg";
import DoubleClick from "./icons/shortcuts/double_click_30x30.svg";
import RightClick from "./icons/shortcuts/right_click_30x30.svg";
import MouseMove from "./icons/shortcuts/mouse_move_30x30.svg";
import MousePan from "./icons/shortcuts/mouse_pan_30x30.svg";
import MouseWheel from "./icons/shortcuts/mouse_wheel_30x30.svg";
import SimpleClick from "./icons/shortcuts/simple_click_30x30.svg";
import Analyst from "./icons/tiles/analyst_24x30.svg";
import AnalyticalDataViewer from "./icons/tiles/analytical_data_24x30.svg";
import ArrayImage from "./icons/tiles/array_24x30.svg";
import BlastTiles from "./icons/tiles/blast_24x30.svg";
import Dashboard from "./icons/tiles/dashboard_24x30.svg";
import Entity from "./icons/tiles/entity_24x30.svg";
import Events from "./icons/tiles/events_24x30.svg";
import SequenceViewer from "./icons/tiles/sequence_viewer_24x30.svg";
import File from "./icons/tiles/file_24x30.svg";
import FileBrowser from "./icons/tiles/file_browser_24x30.svg";
import FilesStack from "./icons/tiles/files_stack_24x30.svg";
import GenomeViewer from "./icons/tiles/genome_viewer_24x30.svg";
import Playbooks from "./icons/tiles/playbooks_24x30.svg";
import Processor from "./icons/tiles/processor_24x30.svg";
import Sample from "./icons/tiles/sample_24x30.svg";
import SampleParent from "./icons/tiles/sample_parent_24x30.svg";
import SamplesStack from "./icons/tiles/samples_stack_24x30.svg";
import SavedGroup from "./icons/tiles/saved_group_24x30.svg";
import SavedItems from "./icons/tiles/saved_items_24x30.svg";
import SavedView from "./icons/tiles/saved_view_24x30.svg";
import Sequences from "./icons/tiles/sequences_24x30.svg";
import Technical from "./icons/tiles/technical_24x30.svg";
import Workflow from "./icons/tiles/workflow_24x30.svg";
import GenedataSelector from "./logos/genedata_selector.svg";
import SelectorApplication from "./logos/selector_application.svg";
import SelectorLogo from "./logos/selector_logo.svg";

export const Logos = {
  GenedataSelector,
  SelectorApplication,
  SelectorLogo,
};

export const Icons = {
  Tiles: {
    Analyst,
    AnalyticalDataViewer,
    Array: ArrayImage,
    Dashboard,
    Entity,
    File,
    SequenceViewer,
    FilesStack,
    FileBrowser,
    Events,
    GenomeViewer,
    Playbooks,
    Processor,
    Sample,
    SampleParent,
    SamplesStack,
    SavedItems,
    SavedGroup,
    SavedView,
    Sequences,
    Workflow,
    Technical,
    Blast: BlastTiles,
  },
  Action: {
    AllProjects,
    AllProjectsBW,
    NewProjects,
    SavedItems: SavedItemsMini,
    GenomeViewer: GenomeViewerMini,
    Sample: SampleMini,
    Blast: BlastMini,
    Processor: ProcessorMini,
    ProcessorBW: ProcessorBWMini,
    Workflow: WorkflowMini,
    WorkflowBW: WorkflowBWMini,
    SequenceViewer: SequenceViewerMini,
    SequenceViewerBW: SequenceViewerBWMini,
    EntitySummaryBW: EntitySummaryBWMini
  },
  Large: {
    Blast,
    AnalyticalDataViewer: AnalyticalDataViewerLarge,
    Playbook: PlaybookLarge,
    GenomeViewer: GenomeViewerLarge,
    PlaybookConfiguration,
    Registration,
    SixteenS,
    Chart,
    Check,
    Configuration,
    Detection,
    Experiment,
    Plants,
    Plate,
    Report,
    Sample1,
    Sample2,
    Scan,
    TLA,
    Vegetables,
    Virus,
    Workflow: WorkflowLarge,
  },
};

export const Shortcuts = {
  SimpleClick,
  DoubleClick,
  MouseMove,
  MousePan,
  MouseWheel,
  RightClick,
};
